export enum WalmartScanRequestType {
  ORDER_DETAIL = 'orderDetail',
  ORDER_RECEIPTS = 'orderReceipts',
  GRAPHQL_REQUESTS = 'graphQlRequests',
}
